import React, { useEffect, useState } from 'react';
import { Api, isFolder, Item as ShareFileItem, UserRole } from '@citrite/sf-api';
import { withModals } from '@sharefiledev/flow-web';
import { App } from 'antd';
import { useAppStore } from '../../../common/store';
import { DocumentTemplateTypes } from '../../../constants';
import { t } from '../../../utils';
import { getFileExtension, isSupportedFileFormat } from '../../../utils/file';
import { AddFromShareFileDialog } from '../AddFromShareFileDialog';

const isMaxFileSize = (selectedItemSize: number) => {
	const maxSignaturePdfSize = 20 * 1024 * 1024;
	return selectedItemSize >= maxSignaturePdfSize;
};

function _FileChooser({
	showModal,
	onClose,
	templateType = DocumentTemplateTypes.Static.type,
}) {
	const { notification } = App.useApp();
	const [modalShown, setModalShown] = useState(false);

	const { user, account } = useAppStore(state => ({
		user: state.user,
		account: state.account,
	}));

	const disableInvalidExtensionFiles = item => {
		if (isFolder(item)) {
			return false;
		}
		const fileExtension = item.FileName && getFileExtension(item.FileName);
		return !isSupportedFileFormat(fileExtension, templateType);
	};

	useEffect(() => {
		const onCloseSuccess = (selectedItems: ShareFileItem[]) => {
			if (selectedItems.length === 1) {
				if (isMaxFileSize(selectedItems[0].FileSizeBytes)) {
					notification.error({
						message: t('maxFileSizeLimitMessage'),
					});
					onDismiss();
					return;
				}
			}

			onClose(selectedItems[0]);
		};

		const onDismiss = () => {
			onClose(null);
		};

		const mount = () => {
			if (!modalShown) {
				setModalShown(true);
				showModal(
					<AddFromShareFileDialog
						accountPreferences={account.Preferences as any}
						disableItems={disableInvalidExtensionFiles}
						onCloseSuccess={onCloseSuccess}
						apiConfiguration={Api.getConfiguration()}
						isMultiselect={false}
						hasHomeFolder={
							account.Preferences.EnableHomeFolders &&
							!user.Roles.includes(UserRole.Client)
						}
						onDismiss={onDismiss}
					/>
				);
			}
		};

		mount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showModal, account, user, onClose, modalShown]);

	return null;
}

export const FileChooser = withModals(_FileChooser);
